import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DraftSelectService } from '../draft-select.service';
import { DraftManagerService } from '../draft-manager.service';

@Component({
  selector: 'app-map-marker',
  templateUrl: './map-marker.component.html',
  styleUrls: ['./map-marker.component.scss']
})
export class MapMarkerComponent implements OnInit {

    /** @var {ElementRef} container['nativeElement'] grants referenece to the HTMLElement of this component's container */
    @ViewChild("container", {static: false, read: ElementRef }) container: ElementRef;
    /** @var {ElementRef} container['nativeElement'] grants referenece to the HTMLElement of this component's title div */
    @ViewChild("title", {static: false, read: ElementRef }) title: ElementRef;
    /** @var {string} Color of this player's team */
    @Input() team: string;
    /** @var {string} Id of this player */
    @Input() player: string;
    /** @var {string} Champion selected by this player */
    public champion: string;
  
    constructor(
      private draftManagerService: DraftManagerService,
      private draftSelectService: DraftSelectService
    ) { }
  
    ngOnInit() {
      this.draftManagerService.draft.subscribe((draft: {}) => this.champion = draft['picks'][this.player]);
    }

    ngAfterViewInit() {
      this.container.nativeElement.classList.add(this.team);
    }

}
